module.exports = __webpack_public_path__ + "static/media/marvelous_03.fd825b03.jpg";